var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32267_188788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.71468 1.87811C7.80449 1.60172 8.19551 1.60172 8.28532 1.87812L9.72876 6.32057C9.76892 6.44418 9.88411 6.52786 10.0141 6.52786H14.6851C14.9758 6.52786 15.0966 6.89975 14.8615 7.07057L11.0825 9.81616C10.9774 9.89255 10.9334 10.028 10.9735 10.1516L12.417 14.594C12.5068 14.8704 12.1904 15.1003 11.9553 14.9294L8.17634 12.1838C8.07119 12.1074 7.92881 12.1075 7.82366 12.1838L4.04469 14.9294C3.80957 15.1003 3.49323 14.8704 3.58304 14.594L5.02648 10.1516C5.06664 10.028 5.02264 9.89255 4.91749 9.81616L1.13852 7.07057C0.903402 6.89975 1.02424 6.52786 1.31485 6.52786H5.98593C6.11589 6.52786 6.23108 6.44418 6.27124 6.32057L7.71468 1.87811Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32267_188788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutlined);
export default __webpack_public_path__ + "static/media/starOutlined.e5edfa51.svg";
export { ForwardRef as ReactComponent };